<template>
<div>
	
	<p class="align-c" v-if="artists_fetched">Add to package for...</p>
	<div v-for="(artist, artist_i) in artists_fetched" :key="'sad'+artist_i">
		<div class="btn btn-full btn-white shadowed" @click="add_to_casting(artist.id)">{{artist.full_name}}</div>
	</div>	

	<p v-if="no_artists_fetched">Sorry, the item cannot add to package since we couldn't find any related artists..</p>

</div>
</template>
<script>
import mixins from '../.././mixins.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 			
		//ImageEditor	
	},

	data(){ return {
		
		artists_fetched: false,
		no_artists_fetched: false,
		
	}},

	computed: {

		media(){
			return this.$store.state.modal.am_add_casting_by_artist.media
		},

		

	},

	methods: {

//---------------------------------------------------------------------

		fetchArtists(){
			if( !this.media ) return

			var _this = this

			this.fetch('fetch_artists_by_media', { media_id:this.media.id }, {
				onSuccess(output){
					
					if( !output.data.result ) {
						//_this.msg('Error: Content not found...')
						_this.no_artists_fetched = true
						return
					}
					_this.artists_fetched = output.data.result
				},
				onError(error){
					//_this.msg('Error: '+error)
					_this.no_artists_fetched = true
				},
			})

		},

//---------------------------------------------------------------------

		add_to_casting( artist_id ){

			if( !artist_id ) return
			if( !this.media.id ) return

			var item = {
				artist_id: artist_id,
				media_id: this.media.id,
			}
      
			this.casting_item_add(item)
			this.triggerIconSignal('check')
			this.close()

			setTimeout(()=>{ document.querySelector('.package-minimenu').classList.add('lookatme') },100)
			setTimeout(()=>{ document.querySelector('.package-minimenu').classList.remove('lookatme') },1200)

		},

//---------------------------------------------------------------------

		close(){
			this.modal_close('am_add_casting_by_artist')
		},

//---------------------------------------------------------------------

	},

	created(){

	},

	mounted(){

		this.fetchArtists()
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/amanagement/AmAddCastingByArtist.vue